
import PoleListPresenter from "../../Pole/PoleList/PoleListPresenter";
import DeleteBtn from "./DeletePlanBtn/DeletePlanBtnPresenter";
import DescriptionPresenter from "./Description/DescriptionPresenter";
import PlanBTImagePresenter from "./PlanBTImage/PlanBTImagePresenter";

import Title from "./Title/TitlePresenter";
import UpdateBtnPresenter from "./UpdateBtn/UpdateBtnPresenter";


export const SinglePlanBT = {
   PlanImage : PlanBTImagePresenter,
   Title : Title,
   Description : DescriptionPresenter,
   DeleteBtn : DeleteBtn,
   UpdateBtn : UpdateBtnPresenter,
   PoleList: PoleListPresenter
}